import { useState } from 'react';
import { Button } from '@geely/ui';
import { ArrowLeft, HelpCircle } from 'lucide-react';
import { useLookupAppointment } from './hooks/useLookupAppointment';
import { LookupSearchForm, AppointmentDetails, EmailVerificationDialog, RecoverAppointmentDialog } from './components';
import { HOME_URL } from '@/lib/constants';

export function LookupAppointmentPage() {
  const [showRecoverForm, setShowRecoverForm] = useState(false);
  const {
    searchedId,
    foundAppointment,
    isLoading,
    store,
    onSearch,
    handleCancel,
    handleReschedule,
    showEmailDialog,
    isVerifying,
    handleEmailVerification,
    closeEmailDialog,
  } = useLookupAppointment();

  return (
    <div className="min-h-screen">
      <div className="container mx-auto px-4 py-12 max-w-2xl">
        <a href={HOME_URL} target="_top">
          <Button variant="ghost" className="mb-6">
            <ArrowLeft className="size-4 mr-2" />
            Voltar
          </Button>
        </a>

        <div className="text-center mb-8">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2">
            Consultar Agendamento
          </h1>
          <p className="text-gray-600">
            Digite o ID do seu agendamento para visualizar os detalhes
          </p>
        </div>

        <LookupSearchForm
          searchedId={searchedId}
          isLoading={isLoading}
          foundAppointment={foundAppointment}
          onSearch={onSearch}
        />

        {foundAppointment && store && (
          <AppointmentDetails
            appointment={foundAppointment}
            store={store}
            onCancel={handleCancel}
            onReschedule={handleReschedule}
          />
        )}

        <EmailVerificationDialog
          isOpen={showEmailDialog}
          isVerifying={isVerifying}
          onSubmit={handleEmailVerification}
          onClose={closeEmailDialog}
        />

        <div className="mt-6 text-center">
          <button
            type="button"
            onClick={() => setShowRecoverForm(true)}
            className="inline-flex items-center gap-2 text-sm text-blue-600 hover:text-blue-800 hover:underline transition-colors"
          >
            <HelpCircle className="size-4" />
            Esqueceu seu código de agendamento?
          </button>
        </div>

        <RecoverAppointmentDialog
          isOpen={showRecoverForm}
          onClose={() => setShowRecoverForm(false)}
        />
      </div>
    </div>
  );
}
